import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Temoignage() {
  const { t } = useTranslation('toiture');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  const scrollToForm = () => {
    const el = document.getElementById('quote-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="temoignage" className="bg-slate-primary py-20 md:py-28 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={ref}
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Image */}
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20Quebec%20house%20with%20new%20dark%20grey%20standing%20seam%20metal%20roof%2C%20modern%20residential%20architecture%20with%20stone%20facade%2C%20Saint-Lawrence%20river%20visible%20in%20the%20background%2C%20warm%20autumn%20afternoon%20light%2C%20landscaped%20front%20yard%2C%20professional%20real%20estate%20exterior%20photography%2C%20warm%20copper%20and%20slate%20color%20grading%2C%20no%20text%20visible&width=800&height=600&seq=toiture-temoin1&orientation=landscape"
                alt="Maison avec toiture tôle neuve à Saint-Nicolas près de Lévis par couvreur RBQ"
                className="w-full h-72 md:h-96 object-cover"
                loading="lazy"
                width="800"
                height="600"
              />
            </div>

            {/* Quote */}
            <div>
              <div className="text-copper text-5xl md:text-6xl font-serif leading-none mb-6">&ldquo;</div>
              <p className="text-white/90 text-base md:text-lg leading-relaxed mb-8">
                {t('temoin_text')}
              </p>
              <div className="mb-8">
                <p className="text-white font-semibold text-sm md:text-base">
                  {t('temoin_name')}
                </p>
                <p className="text-white/60 text-sm">
                  {t('temoin_location')} — {t('temoin_project')}
                </p>
              </div>
              <button
                onClick={scrollToForm}
                className="bg-copper hover:bg-copper-dark text-white font-semibold px-6 py-3 rounded-md text-sm transition-all duration-300 inline-flex items-center gap-2 whitespace-nowrap"
              >
                {t('temoin_cta')}
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <p className="text-white/40 text-xs mt-10 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}